import { CustomerTypeService } from '../../providers'

const CustomerTypeModule = {
  namespaced: true,
  state: {
    customerTypes: []
  },
  mutations: {
    SET_CUSTOMER_TYPES (state, data) {
      state.customerTypes = data
    }
  },
  actions: {
    async fetchCustomerTypes ({ commit }) {
      const result = await CustomerTypeService.fetchCustomerTypes()
      commit('SET_CUSTOMER_TYPES', result)
      return result
    }
  },
  getters: {
    isCustomerTypesEmpty (state) {
      return state.customerTypes.length === 0
    },
    filterJuristicCustomerTypes (state) {
      return state.customerTypes.filter(({ value }) => value !== '5')
    }
  }
}

export default CustomerTypeModule
